import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorApi from './ErrorApi';
import ErrorClient from './ErrorClient';

class ErrorBanner extends Component {
  state = {
    collapse: true,
  };

  /**
   * Copy temporary HTML element value into clipboard
   * @param str
   */
  copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  /**
   * Collapse banner
   * @param e
   */
  handleClick = (e) => {
    e.preventDefault();
    const { collapse } = this.state;

    this.setState({ collapse: !collapse });
  };

  /**
   * Close banner
   * @param e
   */
  handleClose = (e) => {
    e.preventDefault();
    const { onClose } = this.props;

    onClose();
  };

  render() {
    const { errorType, error, pathname } = this.props;
    const { collapse } = this.state;

    // do not display anything if display is false or no error data
    if (!error.display || (error.display && !error.data)) {
      return (null);
    }

    return (
      <div>
        { errorType === 'api' && (
        <ErrorApi
          handleClick={this.handleClick}
          handleClose={this.handleClose}
          handleCopy={content => this.copyToClipboard(content)}
          collapse={collapse}
          pathname={pathname}
          error={error}
        />
        )}
        { errorType === 'client' && (
        <ErrorClient
          handleClick={this.handleClick}
          handleClose={this.handleClose}
          handleCopy={content => this.copyToClipboard(content)}
          collapse={collapse}
          pathname={pathname}
          error={error}
        />
        )}
      </div>
    );
  }
}

ErrorBanner.propTypes = {
  /** String error type */
  errorType: PropTypes.oneOf(['api', 'client']).isRequired,
  /** Object error */
  error: PropTypes.shape().isRequired,
  /** String pathname route location */
  pathname: PropTypes.string.isRequired,
  /** Function callback to close banner */
  onClose: PropTypes.func.isRequired,
};

export default ErrorBanner;
